import { CognitoClient } from './CognitoClient';

export const cognitoClient = new CognitoClient();
